import * as _ from "lodash";
import moment from "moment";
import duration from "moment-duration-format";

duration(moment);

export default {
	methods: {
		secondsToFormat(seconds = 0, format, options) {
			const defaultOptions = {trim: false};
			return moment.duration(seconds, "seconds").format(format, _.extend(defaultOptions, options));
		},

		formatToSeconds(timeString = "", format) {
			return timeString ? moment(timeString, format).diff(moment().startOf('day'), 'seconds') : null;
		}
	}
}